import { useSearchParams } from 'react-router-dom';
import { MediaCall } from './components/MediaCall';

export function AppVideoCall() {
  const [searchParams] = useSearchParams();
  const moduleId = searchParams.get('module') || 'general-coaching';

  return <MediaCall mode="video" moduleId={moduleId} />;
}